<template>
  <v-dialog v-model="showDialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn colo="primary" v-on="on" @click="init">Agregar</v-btn>
    </template>
    <v-card>
      <v-card-title> Nuevo escenario</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="validForm">
          <v-text-field type="text" label="Nombre" v-model="nombre" disabled />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn small color="primary" @click="guardar" :disabled="!validForm"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";

export default {
  props: ['generacionId'],
  components: {},
  data() {
    return {
      nombre: "",
      showDialog: false,
      validForm: false,
      escenarios: [],
    };
  },
  methods: {
    init() {
      axios
        .get("/escenario?generacionId=" + this.generacionId)
        .then((response) => {
          console.log(response);
            this.escenarios = response.data;
            console.log(this.escenarios)
            this.nombre = 'E' + (this.escenarios.length + 1);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    guardar() {
      let data = {
        generacion: {id: this.generacionId},
        nombre: this.nombre,
      };
      console.log("agregar clicked", data);
      axios
        .put("/escenario", data)
        .then((response) => {
          console.log(response);
          this.$emit("agregado", response.data);
          this.$refs.form.reset();
          this.showDialog = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>